import { render, staticRenderFns } from "./DownPage.vue?vue&type=template&id=75ffd0e2&scoped=true&"
import script from "./DownPage.vue?vue&type=script&lang=js&"
export * from "./DownPage.vue?vue&type=script&lang=js&"
import style0 from "./DownPage.vue?vue&type=style&index=0&id=75ffd0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ffd0e2",
  null
  
)

export default component.exports